import {Component, OnInit} from '@angular/core';
import {DomSanitizer} from "@angular/platform-browser";
import {IOption} from "ng-select";
import {BsModalRef} from "ngx-bootstrap";
import {NgxSpinnerService} from "ngx-spinner";
import {HelperService} from "../services/helper.service";
import {RilrService} from "../services/rilr.service";

@Component({
  selector: 'app-communication-log-pdf-viewer',
  templateUrl: './communication-log-pdf-viewer.component.html',
  styleUrls: ['./communication-log-pdf-viewer.component.scss'],
  providers: [RilrService],
})
export class CommunicationLogPdfViewerComponent implements OnInit {

  public masterData: any = [];
  public reportSystemID: number;
  public documentSystemID: number;
  public documentUrl: any = this.sanitizer.bypassSecurityTrustResourceUrl('http://www.africau.edu/images/default/sample.pdf');
  public modelTitle: string;

  constructor(public bsModalRef: BsModalRef,
              private helperService: HelperService,
              private spinner: NgxSpinnerService,
              private rilrService: RilrService,
              private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    setTimeout(() => {
      this.documentUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.masterData.url);
    }, 0);
  }

  public closeModal() {
    const that = this;
    this.bsModalRef.hide();
    that.rilrService
      .storeCommunicationLogHistory()
      .post(this.masterData)
      .subscribe(resp => {
      }, (error) => {
      });
  }

}



// WEBPACK FOOTER //
// /app/src/app/communication-log-pdf-viewer/communication-log-pdf-viewer.component.ts